import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HomeCinemaIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-homeCinema"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M16.7071 24.2929C14.5241 22.4579 13.0001 19.9109 13.0001 16.9999 13.0001 14.0889 14.5241 11.5429 16.7071 9.7069 17.6931 8.8779 16.2721 7.4689 15.2931 8.2929 12.7201 10.4569 11.0001 13.5929 11.0001 16.9999 11.0001 20.4069 12.7201 23.5429 15.2931 25.7069 16.2721 26.5309 17.6941 25.1229 16.7071 24.2929M52.7071 25.7071C55.2801 23.5431 57.0001 20.4071 57.0001 17.0001 57.0001 13.5931 55.2801 10.4571 52.7071 8.2931 51.7281 7.4691 50.3061 8.8771 51.2931 9.7071 53.4751 11.5421 55.0001 14.0891 55.0001 17.0001 55.0001 19.9111 53.4751 22.4571 51.2931 24.2931 50.3071 25.1221 51.7281 26.5311 52.7071 25.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M18.7071 20.2929C18.1221 19.7989 17.7261 19.3459 17.3881 18.6729 17.1391 18.1769 17.0001 17.5659 17.0001 16.9999 17.0001 16.8449 17.0091 16.6899 17.0231 16.5349 17.0311 16.4639 17.0301 16.4659 17.0201 16.5439L17.0371 16.4409C17.0541 16.3559 17.0701 16.2699 17.0891 16.1859 17.1681 15.8469 17.2571 15.5939 17.3631 15.3759 17.7041 14.6799 18.1081 14.2129 18.7071 13.7069 19.1201 13.3589 19.0661 12.6519 18.7071 12.2929 18.2981 11.8839 17.7071 11.9429 17.2931 12.2929 15.9111 13.4599 15.0001 15.1699 15.0001 16.9999 15.0001 18.8299 15.9111 20.5399 17.2931 21.7069 17.7051 22.0549 18.3031 22.1119 18.7071 21.7069 19.0641 21.3499 19.1221 20.6429 18.7071 20.2929M50.7071 21.7071C52.0891 20.5401 53.0001 18.8301 53.0001 17.0001 53.0001 15.1701 52.0891 13.4601 50.7071 12.2931 50.2951 11.9451 49.6971 11.8881 49.2931 12.2931 48.9351 12.6501 48.8781 13.3571 49.2931 13.7071 49.8781 14.2011 50.2731 14.6541 50.6121 15.3271 50.8611 15.8231 51.0001 16.4341 51.0001 17.0001 51.0001 17.1551 50.9901 17.3101 50.9771 17.4651 50.9691 17.5361 50.9701 17.5341 50.9801 17.4561 50.9741 17.4911 50.9691 17.5251 50.9631 17.5591 50.9461 17.6441 50.9301 17.7301 50.9101 17.8141 50.8311 18.1531 50.7431 18.4061 50.6361 18.6241 50.2961 19.3201 49.8921 19.7871 49.2931 20.2931 48.8801 20.6411 48.9341 21.3481 49.2931 21.7071 49.7021 22.1161 50.2931 22.0571 50.7071 21.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M41,2 L27,2 C25.3427153,2 24,3.34271525 24,5 L24,29 C24,30.6572847 25.3427153,32 27,32 L41,32 C42.6572847,32 44,30.6572847 44,29 L44,5 C44,3.34271525 42.6572847,2 41,2 Z M27,4 L41,4 C41.5527153,4 42,4.44728475 42,5 L42,29 C42,29.5527153 41.5527153,30 41,30 L27,30 C26.4472847,30 26,29.5527153 26,29 L26,5 C26,4.44728475 26.4472847,4 27,4 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M34,20.5 C33.1718576,20.5 32.5,21.1718576 32.5,22 C32.5,22.8281424 33.1718576,23.5 34,23.5 C34.8281424,23.5 35.5,22.8281424 35.5,22 C35.5,21.1718576 34.8281424,20.5 34,20.5 Z M34,21.5 C34.2758576,21.5 34.5,21.7241424 34.5,22 C34.5,22.2758576 34.2758576,22.5 34,22.5 C33.7241424,22.5 33.5,22.2758576 33.5,22 C33.5,21.7241424 33.7241424,21.5 34,21.5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M35,10 C35,10.552 34.552,11 34,11 C33.448,11 33,10.552 33,10 C33,9.448 33.448,9 34,9 C34.552,9 35,9.448 35,10"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M34 16C30.6867153 16 28 18.6867153 28 22 28 25.3132847 30.6867153 28 34 28 37.3132847 28 40 25.3132847 40 22 40 18.6867153 37.3132847 16 34 16ZM34 18C36.2087153 18 38 19.7912847 38 22 38 24.2087153 36.2087153 26 34 26 31.7912847 26 30 24.2087153 30 22 30 19.7912847 31.7912847 18 34 18ZM34 6C31.7908576 6 30 7.79085763 30 10 30 12.2091424 31.7908576 14 34 14 36.2091424 14 38 12.2091424 38 10 38 7.79085763 36.2091424 6 34 6ZM34 7C35.6568576 7 37 8.34314237 37 10 37 11.6568576 35.6568576 13 34 13 32.3431424 13 31 11.6568576 31 10 31 8.34314237 32.3431424 7 34 7Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
